import Group from "@/comn/components/Group";
import { Page } from "@/comn/components/Page";
import { useForm, useModal, useResource, useToast } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { Button, Layout } from "@/comn/components";
import { BASE, SF_ANY_AUTH } from "@/comn/comn/auth/services/AnyAuthService";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import {useSetRecoilState} from "recoil";
import {authState} from "@/comn/features/recoil";

/*
 * Anonymous Authentication
 * !== 익명 인증 ==!
 */
export const AnyAuth = (props:any) => {
    const toast    = useToast();
    const modal    = useModal();
    const { t }    = useTranslation();
    const setAuth  = useSetRecoilState(authState);
    const {close}  = props;

    const form = { anyAuth: useForm({ defaultSchema: SF_ANY_AUTH }) };

    useResource({ defaultSchema: [{ area: "comnCd", comnCd: "CGM0167" }] });

    const handler = {
        onSubmitBtnClick: form.anyAuth.handleSubmit(async () => {
            try {
                const pwd     = form.anyAuth.getValue("pwd");
                const pwdCfrm = form.anyAuth.getValue("pwdCfrm");

                form.anyAuth.clearErrors("pwdCfrm");
                if (pwd !== pwdCfrm) {
                    form.anyAuth.setError("pwdCfrm", {
                        // Passwords do not match. !== 비밀번호가 일치하지 않습니다. ==!
                        type: "error",
                        message: "msg.ptl.00712",
                    });
                    return;
                }

                window.sessionStorage.removeItem("user-info");
                Cookies.remove("authorization");
                Cookies.remove("refreshauthorization");

                /* dev */
                if (process.env.NODE_ENV === "development") {
                    const systemGroup = process.env.REACT_APP_SYSTEM_GROUP || "";
                    Cookies.remove(`authorization_${systemGroup}`);
                    Cookies.remove(`refreshauthorization_${systemGroup}`);
                }

                const response = await api.post(`${BASE.api}/api/v1/ptl/comn/comn/login/any`, { ...form.anyAuth.getValues() });

                // Authentication successful. Would you like to proceed to the next step? If canceled, your authentication will be revoked.
                // !== 인증 되었습니다. 다음으로 진행 하겠습니까? 취소 시 인증이 취소됩니다. ==!
                modal.openModal({
                    content: "msg.ptl.00776",
                    onConfirm: () => {
                        const { authorization } = response.headers;
                        const { userInfo }      = response.data;
                        Cookies.set("authorization", authorization.substring(7));

                        /* dev */
                        if (process.env.NODE_ENV === "development") {
                            const systemGroup = process.env.REACT_APP_SYSTEM_GROUP || "";
                            Cookies.set(`authorization_${systemGroup}`, authorization.substring(7));
                        }

                        setAuth( { userInfo: userInfo.content, isSignedIn: false, isInitialized: true, signedAt: userInfo.xpirDt  } );
                    }
                });
            } catch (e: any) {
                const { response } = e;

                if (comnUtils.isEmpty(response)) {
                    toast.showToast({ type: "error", content: e.message });
                } else {
                    toast.showToast({ type: "error", content: e.response.data.errorMessage.content });
                }
            }
        }),
        onBtnClose: () => {
            close();
        },
        onChangeAuthTpCd: (param: any) => {
            const { label, code } = param;

            const lengthMap: any = { D: 50, E: 100, N: 100, O: 100, P: 9, T: 10 };
            form.anyAuth.setSchema("id", { ...form.anyAuth.schema.id, label: label, maxLength: lengthMap[code] });
            form.anyAuth.setValue("id"     , "");
            form.anyAuth.setValue("pwd"    , "");
            form.anyAuth.setValue("pwdCfrm", "");
        }
    };

    useEffect(() => {
        // process.env.REACT_APP_SYSTEM_GROUP !== "tanesw" && navigate("/403");
    }, []);

    return (
        <Page>
            <Group.Any/>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.anyAuth.schema.authTpCd} callback={handler.onChangeAuthTpCd} />
                        </Group.Row>
                        {form.anyAuth.getValue("authTpCd") && (
                            <>
                                <Group.Row>
                                    <Group.Control {...form.anyAuth.schema.id} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.anyAuth.schema.pwd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.anyAuth.schema.pwdCfrm} />
                                </Group.Row>
                            </>
                        )}
                    </Group.Section>

                    <Group.Section>
                        <Layout.Right>
                            <Button onClick={handler.onSubmitBtnClick}>{t("L_LOGIN")}</Button>
                            <Button role={"close"} onClick={handler.onBtnClose}/>
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group.Any/>
        </Page>
    );
};
